import { Injectable, Injector } from '@angular/core';
import { Route, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteAuthorizationService {
  constructor(
    private injector: Injector,
    private router: Router
  ) { }

  /**
   * Checks if a route can be activated by evaluating its guards.
   * Accepts either a Route object or a string path.
   * If a string path is provided, looks up the route in the router config.
   * Returns true if the route has no guards or all guards pass.
   * Returns false if any guard fails or route is not found.
   */
  async checkCanActivate(routeOrPath: Route | string): Promise<boolean> {
    let route: Route | undefined;

    // If string path provided, look up the route
    if (typeof routeOrPath === 'string') {
      const path = routeOrPath.startsWith('/') ? routeOrPath.substring(1) : routeOrPath;
      route = this.router.config.find(r => r.path === path);
      if (!route) {
        console.warn(`Route not found for path: ${routeOrPath}`);
        return false;
      }
    } else {
      route = routeOrPath;
    }

    // Check if route has guards
    if (!route.canActivate || route.canActivate.length === 0) {
      return true;
    }

    // Evaluate all guards
    for (const guard of route.canActivate) {
      const guardInstance = this.injector.get(guard);
      const result = await guardInstance.canActivate();
      if (!result) {
        return false;
      }
    }

    return true;
  }
}
